import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation();
  const referralText = t("hero.referral");

  return (
    <section
      id="hero"
      className="relative min-h-screen w-full flex items-center pb-28 md:pb-40 overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20ultra%20luxury%20private%20music%20studio%20interior%20at%20night%20silhouette%20of%20a%20magnificent%20grand%20piano%20under%20dramatic%20single%20spotlight%20beam%20deep%20black%20and%20warm%20charcoal%20walls%20subtle%20champagne%20gold%20accent%20lighting%20from%20recessed%20fixtures%20floating%20dust%20particles%20in%20light%20rays%20minimalist%20zen-like%20silence%20atmosphere%20ultra%20high-end%20executive%20club%20aesthetic%20no%20visible%20text%20or%20logos%20professional%20architectural%20photography&width=1920&height=1080&seq=1&orientation=landscape"
          alt="Luxury music studio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-deepblack/50 via-deepblack/35 to-deepblack/75" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl">
          <span className="inline-block px-5 py-2 border-2 border-champagne/50 rounded-full text-champagne text-sm font-sans tracking-widest uppercase mb-3 bg-champagne/10">
            {t("hero.tag")}
          </span>
          {referralText && (
            <p className="text-marble/50 text-xs md:text-sm font-sans leading-relaxed mb-6 max-w-xl">
              {referralText}
            </p>
          )}

          <h1 className="font-serif text-marble leading-tight">
            <span className="block text-4xl md:text-6xl lg:text-7xl font-light tracking-wide whitespace-nowrap">
              {t("hero.title1")}
            </span>
            {t("hero.title2") && (
              <span className="block text-4xl md:text-6xl lg:text-7xl font-light tracking-wide mt-1">
                {t("hero.title2")}
              </span>
            )}
          </h1>

          <div className="mt-8 space-y-2">
            <p className="text-marble/95 text-sm md:text-base font-sans leading-relaxed max-w-lg drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">
              {t("hero.description1")}
            </p>
            {t("hero.description2") && (
              <p className="text-marble/80 text-sm md:text-base font-sans leading-relaxed max-w-lg drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">
                {t("hero.description2")}
              </p>
            )}
            {t("hero.description3") && (
              <p className="text-marble/80 text-sm md:text-base font-sans leading-relaxed max-w-lg drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">
                {t("hero.description3")}
              </p>
            )}
          </div>

          <a
            href="/inquiry"
            className="inline-flex items-center gap-3 mt-10 bg-champagne hover:bg-champagne/90 text-deepblack px-8 py-3.5 rounded-full text-sm font-sans tracking-widest uppercase transition-all duration-300 group"
          >
            {t("cta.button")}
            <span className="w-6 h-6 rounded-full bg-deepblack/20 flex items-center justify-center group-hover:bg-deepblack/30 transition-colors">
              <i className="ri-arrow-right-line text-deepblack" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}